import {geocodeAddress} from "@/src/modules/properties/lib/census-geocode";

export function parseGpsCoordinates(gpsCoordinates: string): [number, number] | null {
  const parts = gpsCoordinates.trim().split(",");
  if (parts.length !== 2) return null;
  const lat = parseFloat(parts[0]!);
  const lng = parseFloat(parts[1]!);
  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
  return [lat, lng];
}

type HouseholdGeocodeFields = {
  number?: string | number | null;
  street?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode?: string | null;
};

export async function resolveHouseholdMapPosition(
  household: HouseholdGeocodeFields,
  propertyGps?: string | null,
): Promise<[number, number] | null> {
  const number = String(household.number ?? "").trim();
  const street = String(household.street ?? "").trim();
  const city = String(household.city ?? "").trim();
  const state = String(household.state ?? "").trim();
  const zip = String(household.zipcode ?? "").trim();

  if (number && street && city && state) {
    try {
      const result = await geocodeAddress({number, street, city, state, zip});
      if (result) {
        return [result.lat, result.lng];
      }
    } catch {
      // Fall through only when household address is incomplete.
    }
    // Complete household address but no geocode match — avoid property GPS fallback
    // (property center can be wrong for another household or stale after account switch).
    return null;
  }

  if (propertyGps?.trim()) {
    return parseGpsCoordinates(propertyGps);
  }

  return null;
}
